export default async function asyncFunction<T>(
	callback: () => Promise<T>,
): Promise<[T | undefined, Error | undefined]> {
	let result;
	let error: Error | undefined;
	try {
		result = await callback();
	} catch (e) {
		error = e as Error;
	}
	return [result, error];
}
